import React, { useState } from 'react';

interface EnterpriseFormProps {
  onSubmit: (formData: any) => Promise<void>;
  onCancel: () => void;
  initialData?: any;
}

const EnterpriseForm: React.FC<EnterpriseFormProps> = ({ onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    description: initialData?.description || '',
    email: initialData?.contactInfo?.email || initialData?.email || '',
    phone: initialData?.contactInfo?.phone || initialData?.phone || '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      alert('Enterprise name is required');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({
        ...formData,
        type: 'enterprise'
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="label-modern">Enterprise Name *</label>
        <input
          type="text"
          className="input-modern"
          placeholder="Enter enterprise name"
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Description</label>
        <textarea
          className="input-modern"
          placeholder="Enterprise description"
          rows={3}
          value={formData.description}
          onChange={(e) => handleChange('description', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Contact Email</label>
        <input
          type="email"
          className="input-modern"
          placeholder="contact@enterprise.com"
          value={formData.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Contact Phone</label>
        <input
          type="tel"
          className="input-modern"
          placeholder="(555) 123-4567"
          value={formData.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
        />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn-modern btn-modern-secondary"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn-modern btn-modern-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? (initialData ? 'Updating...' : 'Creating...') : (initialData ? 'Update Enterprise' : 'Create Enterprise')}
        </button>
      </div>
    </form>
  );
};

export default EnterpriseForm;